import React from "react";

import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import useFragment from "@/hooks/useFragment";

interface Props {
  id: string;
}

const mealFoodItemFragment = graphql(`
  fragment MealFoodItem on MealFood {
    id
    food {
      id
      name
    }
    foodPortion {
      id
      unitWithModifier
    }
    carbohydrateGrams
    proteinGrams
    fatGrams
    amount
    energyKcal
  }
`);

const MealFoodItem: React.FC<Props> = ({ id }) => {
  const { classes } = useStyles();
  const [mealFood] = useFragment(mealFoodItemFragment, `MealFood:${id}`);

  return (
    <div>
      <Typography className={classes.food}>{mealFood?.food.name}</Typography>
      <Typography className={classes.eaten}>
        {mealFood?.energyKcal.toFixed()} kcal | {mealFood?.amount}{" "}
        {mealFood?.foodPortion.unitWithModifier}
      </Typography>
    </div>
  );
};

const useStyles = makeStyles()({
  food: {
    color: "#363E45",
  },
  eaten: {
    marginTop: 4,
    color: "#4C515A",
    fontSize: 14,
    fontWeight: 600,
  },
  macros: {
    display: "flex",
    justifyContent: "space-between",
    margin: 2,
  },
});

export default MealFoodItem;
